import React from 'react'
import { Button } from '@mui/material'
import colors from '../theme/colors'
import { useTranslation } from "react-i18next"
import { TooltipButton } from './commons/TooltipButton'
import { styled } from '@mui/material/styles'
import LoadingButton from '@mui/lab/LoadingButton'
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import InfoIcon from '@mui/icons-material/Info'

export const ObtenerInformesButtons = ({ loading, setLoading, listaEjes, GetCuestionarioReportParcial, handleOpenFinalizarCuestionario, handleShowInfoModal  }) => {

    const { t } = useTranslation()

    const IconButton = styled(Button)(() => ({
        padding: '6px 6px',
        minWidth: '35px',
        height: '35px'
    }));

    return (
        <>
            <TooltipButton
                titulo={t("eje.informeParcialTitle")}
                body={t("eje.informeParcialBody")}
            >
                <span>                
                    {listaEjes?.porcentajeCuestionario != 100 && (
                    <LoadingButton
                        onClick={() => {
                            setLoading(true);
                            GetCuestionarioReportParcial(
                                listaEjes.id_cuestionario
                            );
                        }}
                        loading={loading}
                        variant="contained"
                        sx={{ padding: "0.5em" }}
                        endIcon={<PictureAsPdf sx={{ color: colors.textMain }} />}
                        loadingPosition="end"
                        disabled={
                            listaEjes?.ejes?.filter(
                                (eje) => eje.porcentaje === 100
                            )?.length === 0
                        }
                    >
                        {t("eje.botonReportParcial")}
                    </LoadingButton>
                    )}
                </span>
            </TooltipButton>
            <Button
                onClick={handleOpenFinalizarCuestionario}
                variant="contained"
                sx={{ padding: "0.5em" }}
                disabled={
                    listaEjes.porcentajeCuestionario !== 100 && true
                }
            >
                {t("eje.botonFinalizar")}
            </Button>
            <IconButton onClick={handleShowInfoModal} sx={{ borderRadius: '50%' }}>
                <InfoIcon />
            </IconButton>
        </>
    )
}
